import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { createClub } from "../../../../services/club";
import { Speciality } from "../../../../interfaces/speciality";
import { useState } from "react";
import Uploader from "../../../general/uploader";
import { Media } from "../../../../interfaces/media";
import { regionsList } from "../../../../data/regions.";

interface AdminClubNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminClubNew(props: AdminClubNewProps) {
    const [media, setMedia] = useState<Media[]>([]);
    const [specialities, setSpecialities] = useState<Speciality[]>([]);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            document_id: event.target.document_id.value,
            date_foundation: event.target.date_foundation.value,
            city: event.target.city.value,
            region: event.target.region.value,
            country: event.target.country.value,
            website: event.target.website.value,
            email: event.target.email.value,
            address: event.target.address.value,
            phone: event.target.phone.value,
            registry_num: event.target.registry_num.value,
            logo: media.length > 0 ? media[0].id : 0
        }
        createClub(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }

    return (
        <Modal className="admin-club-new-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_club") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Container>
                            <Row>
                                <Col xs={12}>
                                    <Form.Control type="hidden" name="country" value="es" />
                                    <Form.Group className="mb-3" controlId="name">
                                        <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                        <Form.Control type="text" name="name" required />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="document_id">
                                        <Form.Label>{ t("document_id") }</Form.Label>
                                        <Form.Control type="text" name="document_id" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="date_foundation">
                                        <Form.Label>{ t("date_foundation") }</Form.Label>
                                        <Form.Control type="date" name="date_foundation" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="region">
                                        <Form.Label>{ t("region") }</Form.Label>
                                        <Form.Select aria-label={t("region")}>
                                            <option value="">{ t("select_region") }</option>
                                            { regionsList.map((r: any) => {
                                                return <option key={ 'region-' + r.code} value={ r.code }>
                                                    { r.label }
                                                </option>
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="city">
                                        <Form.Label>{ t("city") }</Form.Label>
                                        <Form.Control type="text" name="city" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="website">
                                        <Form.Label>{ t("website") }</Form.Label>
                                        <Form.Control type="text" name="website" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label>{ t("email") }</Form.Label>
                                        <Form.Control type="text" name="email" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" controlId="address">
                                        <Form.Label>{ t("address") }</Form.Label>
                                        <Form.Control type="text" name="address" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Label>{ t("phone") }</Form.Label>
                                        <Form.Control type="text" name="phone" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="registry_num">
                                        <Form.Label>{ t("registry_num") }</Form.Label>
                                        <Form.Control type="text" name="registry_num" />
                                    </Form.Group>
                                </Col>
                                <Form.Group className="mb-3 media-field" controlId="media">
                                    <Uploader title={ t("icon_upload_message") }
                                        media={ media } save={ handleMediaEventUpload } />
                                </Form.Group>
                            </Row>
                        </Container>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
